import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faLocationDot, faPhoneFlip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NetWorkService, validResponse } from '@utils/API'
import { CODE_SUCCESS } from '@utils/constan'
import { detectEnvUat } from '@utils/general'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Type_Initstate } from 'store/appSlice'
import { IGroupDetail } from '../../types/general'

const Footer = () => {
  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)
  const { edubillDetail } = appState
  const [dataGroup, setDataGroup] = useState<IGroupDetail>()
  const { Get } = NetWorkService
  const path = window.location.pathname // "/search/dhnt/school/dhcq"
  const parts = path.split('/') // ["", "search", "dhnt", "school", "dhcq"]

  const orgCode = detectEnvUat() ? parts[3] : parts[2] // "dhnt"
  const schoolCode = detectEnvUat() ? parts[5] : parts[4] // "dhcq"
  const getData = async () => {
    console.log('getData2')
    try {
      const res: any = await Get<any>({
        url: `/api/organization/${orgCode}/detail`,
      })
      if (res && validResponse(res) && res.code === CODE_SUCCESS) {
        const response = res?.data.data
        console.log(response)
        console.log(orgCode, schoolCode)
        setDataGroup(response)
      } else {
        // Sentry.captureMessage('Lấy dữ liệu lỗi')
      }
    } catch (error) {
      console.log(error)
      // Sentry.captureException(error)
    }
  }
  useEffect(() => {
    if (orgCode && !schoolCode) {
      getData()
    }
  }, [orgCode, schoolCode])
  return (
    <>
      {!appState.isHome && (
        <div className="px-12 py-6 bg-white items-end">
          <div
            className="flex items-center pt-5"
            style={{
              borderTop: '2px solid rgba(0, 80, 134, 0.15)',
            }}
          >
            <img
              src={!schoolCode ? dataGroup?.logo : edubillDetail?.avatarUrl}
              alt=""
              className="w-[76px] h-[76px] opacity-90"
            />
            {/* <span
              className="text-[#005086] md:text-[22px] font-[700] pl-5 text-[16px]"
              dangerouslySetInnerHTML={{
                __html: !schoolCode ? dataGroup?.orgName : edubillDetail?.schoolName,
              }}
            /> */}
          </div>
          <p className="text-[#005086] text-[18px] md:text-[24px] font-[500] py-6 ">THÔNG TIN LIÊN HỆ</p>
          <div className="flex flex-col md:flex-row">
            <div className="flex flex-col pr-6">
              {/* {edubillDetail?.orgCode === 'dhqt' || !schoolCode ? (
                <p className="text-[#005086] text-[15px] pb-4">Phòng Kế hoạch Tài chính</p>
              ) : (
                <p
                  className="text-[#005086] text-[15px] pb-4"
                  dangerouslySetInnerHTML={{
                    __html: edubillDetail?.schoolName,
                  }}
                />
              )} */}
              <div className="flex flex-col md:pt-0 pt-5">
                <p className="text-[#005086] text-[15px] pb-4">
                  <FontAwesomeIcon icon={faLocationDot} /> Địa chỉ:{' '}
                  {!schoolCode ? dataGroup?.address : edubillDetail?.address}
                </p>
                {/* <p className="text-[#ffffffbf] text-[15px]">
                <FontAwesomeIcon icon={faFax} /> Fax: {edubillDetail?.fax}
              </p> */}
              </div>
              <p className="text-[#005086] text-[15px] pb-4">
                <FontAwesomeIcon icon={faPhoneFlip} /> Điện thoại:{' '}
                {!schoolCode ? dataGroup?.phone : edubillDetail?.phone}
              </p>
              <p className="text-[#005086] text-[15px]">
                <FontAwesomeIcon icon={faEnvelope} /> Email: {!schoolCode ? dataGroup?.email : edubillDetail?.email}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default Footer
